
import { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { DeleteInventoryPeriodDialog } from "../dashboard/management/inventory/DeleteInventoryPeriodDialog";

interface PeriodListProps {
  periods: any[];
  isLoading: boolean;
  onPeriodSelect: (periodId: string) => void;
}

export const PeriodList = ({ periods, isLoading, onPeriodSelect }: PeriodListProps) => {
  const [periodToDelete, setPeriodToDelete] = useState<{id: string, name: string} | null>(null);
  
  return (
    <div className="space-y-4">
      {isLoading ? (
        <p>Chargement des périodes...</p>
      ) : periods.length ? (
        periods.map((period) => (
          <Card 
            key={period.id} 
            className="hover:border-primary transition-colors"
          >
            <CardHeader className="p-4 pb-2">
              <CardTitle className="text-lg flex justify-between items-center">
                <span>{period.period_name}</span>
                <Button
                  variant="ghost"
                  size="icon"
                  className="h-8 w-8 text-destructive hover:text-destructive hover:bg-destructive/10"
                  onClick={(e) => {
                    e.stopPropagation();
                    setPeriodToDelete({
                      id: period.id,
                      name: period.period_name
                    });
                  }}
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </CardTitle>
              <CardDescription>
                Du {new Date(period.start_date).toLocaleDateString()} au {new Date(period.end_date).toLocaleDateString()}
              </CardDescription>
            </CardHeader>
            <CardContent className="p-4 pt-0" onClick={() => onPeriodSelect(period.id)}>
              <div className="flex justify-between items-center">
                <span className={`px-2 py-1 text-xs rounded-full ${
                  period.status === 'active' 
                    ? 'bg-green-100 text-green-800' 
                    : period.status === 'completed'
                    ? 'bg-blue-100 text-blue-800'
                    : 'bg-gray-100 text-gray-800'
                }`}>
                  {period.status === 'active' ? 'Actif' : 
                   period.status === 'completed' ? 'Terminé' : 'Planifié'}
                </span>
                <span className="text-sm text-muted-foreground">
                  Créé le {new Date(period.created_at).toLocaleDateString()}
                </span>
              </div>
            </CardContent>
          </Card>
        ))
      ) : (
        <Card>
          <CardContent className="p-6 text-center">
            <p>Aucune période d'inventaire n'a été trouvée.</p>
          </CardContent>
        </Card>
      )}
      
      {periodToDelete && (
        <DeleteInventoryPeriodDialog
          open={!!periodToDelete}
          onOpenChange={() => setPeriodToDelete(null)}
          periodId={periodToDelete.id}
          periodName={periodToDelete.name}
        />
      )}
    </div>
  );
};
